$(document).ready(function () {
  // Currency Global Variables
  let moneySpanSelector = "span.money",
    currencyPickerSelector = "[name=currencies]",
    activeCurrencySelector = ".js-active-currency",
    currencyNoteSelector = ".js-cart-currency-note";

  let currencyPicker = {
    loadCurrency: function () {
      if (typeof $ === "undefined") return;

      $(moneySpanSelector + " " + moneySpanSelector).each(function () {
        if ($(this).parents(moneySpanSelector).length) {
          $(this).parents(moneySpanSelector).removeClass("money");
        }
      });

      $(moneySpanSelector).each(function () {
        $(this).attr("data-currency-" + shopCurrency, $(this).html());
      });

      if (typeof cookieCurrency === "undefined") {
        var cookieCurrency = null;
      }

      if (cookieCurrency == null) {
        if (
          typeof shopCurrency !== "undefined" &&
          typeof defaultCurrency !== "undefined" &&
          shopCurrency !== defaultCurrency
        ) {
          if (typeof Currency !== "undefined") {
            Currency.convertAll(shopCurrency, defaultCurrency);
          }
        } else {
          if (typeof Currency !== "undefined") {
            Currency.currentCurrency = defaultCurrency;
          }
        }
      } else if (
        $(currencyPickerSelector).length &&
        $(currencyPickerSelector + " option[value=" + cookieCurrency + "]")
          .length === 0
      ) {
        if (typeof Currency !== "undefined") {
          Currency.currentCurrency = shopCurrency;
          Currency.cookie.write(shopCurrency);
        }
      } else if (cookieCurrency === shopCurrency) {
        if (typeof Currency !== "undefined") {
          Currency.currentCurrency = shopCurrency;
        }
      } else {
        $(currencyPickerSelector).val(cookieCurrency);
        if (typeof Currency !== "undefined") {
          Currency.convertAll(shopCurrency, cookieCurrency);
        }
      }

      currencyPicker.setCurrencyText();
    },
    onCurrencyChanged: function (event) {
      let newCurrency = $(this).val(),
        $otherPickers = $(currencyPickerSelector).not($(this));

      if (typeof Currency !== "undefined") {
        Currency.convertAll(Currency.currentCurrency, newCurrency);
        currencyPicker.setCurrencyText(newCurrency);
      }

      if ($otherPickers.length > 0) {
        $otherPickers.val(newCurrency);
      }
    },
    setCurrencyText: function (newCurrency) {
      if (
        typeof newCurrency === "undefined" &&
        typeof Currency !== "undefined"
      ) {
        newCurrency = Currency.currentCurrency;
      }

      let $activeCurrency = $(activeCurrencySelector),
        $currencyNote = $(currencyNoteSelector);

      if ($activeCurrency.length > 0) {
        $activeCurrency.text(newCurrency);
      }

      if ($currencyNote.length > 0) {
        if (newCurrency !== shopCurrency) {
          $currencyNote.show();
        } else {
          $currencyNote.hide();
        }
      }
    },
    onMoneySpanAdded: function () {
      if (typeof Currency !== "undefined") {
        Currency.convertAll(shopCurrency, Currency.currentCurrency);
        currencyPicker.setCurrencyText();
      }
    },
    init: function () {
      if (
        typeof showMultipleCurrencies !== "undefined" &&
        showMultipleCurrencies !== true
      ) {
        return false;
      }

      currencyPicker.loadCurrency();

      $(document).on(
        "change",
        currencyPickerSelector,
        currencyPicker.onCurrencyChanged
      );
    },
  };

  currencyPicker.init();

  // Add to Cart Form
  let addToCartFormSelector = "#add-to-cart-form",
    productOptionSelector = addToCartFormSelector + " [name*=option]";

  let productForm = {
    onProductOptionChanged: function (event) {
      let $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      $form.trigger("form:change", [selectedVariant]);
    },
    getActiveVariant: function ($form) {
      if (
        typeof JSON === "undefined" ||
        typeof decodeURIComponent === "undefined"
      )
        return null;

      let variants = JSON.parse(
          decodeURIComponent($form.attr("data-variants"))
        ),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null,
        },
        selectedVariant = null;

      $.each(formData, function (index, item) {
        if (item.name.indexOf("option") !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      $.each(variants, function (index, variant) {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          return false;
        }
      });

      return selectedVariant;
    },
    validate: function (event, selectedVariant) {
      let $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find(".js-variant-id"),
        $addToCartButton = $form.find("#add-to-cart-button"),
        $price = $form.find(".js-price"),
        formattedVariantPrice,
        priceHtml;

      if (hasVariant) {
        formattedVariantPrice = "$" + (selectedVariant.price / 100).toFixed(2);
        priceHtml = '<span class="money">' + formattedVariantPrice + "</span>";
      } else {
        priceHtml = $price.attr("data-default-price");
      }

      if (canAddToCart) {
        $id.val(selectedVariant.id);
        $addToCartButton.prop("disabled", false);
      } else {
        $id.val("");
        $addToCartButton.prop("disabled", true);
      }

      $price.html(priceHtml);
      currencyPicker.onMoneySpanAdded();
    },
    init: function () {
      $(document).on(
        "change",
        productOptionSelector,
        productForm.onProductOptionChanged
      );
      $(document).on(
        "form:change",
        addToCartFormSelector,
        productForm.validate
      );
    },
  };

  productForm.init();

  // Search Input
  let searchInputSelector = ".js-search-input",
    searchSubmitSelector = ".js-search-submit",
    onSearchInputKeyup = function (event) {
      let $form = $(this).closest("form"),
        $button = $form.find(searchSubmitSelector),
        shouldDisableButton = this.value.length === 0;

      $button.prop("disabled", shouldDisableButton);
    };

  $(document).on("keyup", searchInputSelector, onSearchInputKeyup);

  // Slideshows
  let slidesSelector = ".js-slides",
    prevButtonSelector = ".js-slider-button-prev",
    nextButtonSelector = ".js-slider-button-next";

  // Product
  let productSlideshowSelector = ".js-product-slideshow",
    currentSlideSelector = ".js-current-slide",
    productSlideshows = {
      onBeforeChange: function (event, slick, currentSlide, nextSlide) {
        let $currentSlide = slick.$slider
          .closest(productSlideshowSelector)
          .find(currentSlideSelector);

        $currentSlide.text(nextSlide + 1);
      },
      setup: function ($element) {
        let $slides = $element.find(slidesSelector),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          productSlideshowOptions = {
            fade: true,
            nextArrow: $nextButton,
            prevArrow: $prevButton,
          };

        if ($slides.children().length > 1) {
          $slides
            .on("beforeChange", productSlideshows.onBeforeChange)
            .slick(productSlideshowOptions);
        }
      },
      init: function () {
        $(productSlideshowSelector).each(function () {
          productSlideshows.setup($(this));
        });
      },
    };

  productSlideshows.init();

  // Section Slideshow
  let sectionSlideshowSelector = ".js-section-slideshow",
    sectionSlideshows = {
      setup: function ($element) {
        let $slides = $element.find(slidesSelector),
          shouldAutoplay = $element.attr("data-autoplay") === "true",
          autoplaySpeed = parseInt($element.attr("data-autoplay-speed")),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          sectionSlideshowOptions = {
            fade: true,
            nextArrow: $nextButton,
            prevArrow: $prevButton,
            autoplay: shouldAutoplay,
            autoplaySpeed: autoplaySpeed,
          };

        if ($slides.children().length > 1) {
          $slides.slick(sectionSlideshowOptions);
        }
      },
      init: function () {
        $(sectionSlideshowSelector).each(function () {
          sectionSlideshows.setup($(this));
        });
      },
    };

  sectionSlideshows.init();
});
